// extracted by mini-css-extract-plugin
export default {"container":"homePage_container__CQRgO","title":"homePage_title__+O978","paginationBtn":"homePage_paginationBtn__7j771"};